import { useEffect } from 'react';
import { app } from "@microsoft/teams-js";
import { TeamsRoutes } from '../../routes/route.path';
import Config from '../../../config';

const MicrosoftLoginStartSSO = () => {
    useEffect(() => {
        // const scope = "https://graph.microsoft.com/user.read https://graph.microsoft.com/files.read"
        app.initialize().then(() => {
            const authorizeParams = new URLSearchParams({
                tenant: "edb4c8cb-528b-440e-a593-0869c59f1018",
                client_id: Config.SSO_LOGIN_AZURE_AD_CLIENT_ID,
                response_type: "code",
                scope: "https://graph.microsoft.com/.default",
                redirect_uri: window.location.origin + TeamsRoutes.TEAMS_CONCENTPOPUP_END_SSO
            });

            const authorizeEndpoint = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${authorizeParams.toString()}`;

            console.log("authorizeEndpoint:", authorizeEndpoint);

            window.location.assign(authorizeEndpoint);
        })

    }, []);

    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>Redirecting to Azure AD to request permission consent</p>
            </div>
        </div>
    );
};

export default MicrosoftLoginStartSSO;
